import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {useState} from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles.css';
import ContentState from "draft-js/lib/ContentState";

const TextEditor = ({label , value , onChange}) => {
    const [tempText , setTempText] = useState(value ? EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(value).contentBlocks)) : EditorState.createEmpty())
    return (
        <div className={'card'}>
        <div className={'card-body'}>
            {label && <label className="card-title mb-2">{label}</label>}
            <Editor
                editorState={tempText}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                // onEditorStateChange={onChange}
                onEditorStateChange={ (editorState) => {
                    setTempText(editorState);
                    onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())))
                }}

            />
            {/*<textarea
                disabled
                value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
            />*/}
        </div>
        </div>
    );
}

export const TextEditorWithoutContainer = ({label , value , onChange}) => {
    const [tempText , setTempText] = useState(value ? EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(value).contentBlocks)) : EditorState.createEmpty())
    return (
        <div>
            {label && <label className="card-title mb-2">{label}</label>}
            <Editor
                editorState={tempText}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                // onEditorStateChange={onChange}
                onEditorStateChange={ (editorState) => {
                    setTempText(editorState);
                    onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())))
                }}

            />
            {/*<textarea
                disabled
                value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
            />*/}
        </div>
    );
}

export default TextEditor;